import Icon from '~components/ui/icon'
import Label from '~components/ui/label'

type HeaderProps = Readonly<{
  withSeeMore?: boolean
}>

const Header = ({ withSeeMore = false }: HeaderProps) => {
  return (
    <>
      <div className="flex h-[62px] items-center justify-between">
        <div>
          <Label className="hidden lg:block">Dr.Tail AI</Label>
          <div className="flex items-center flex-gap-x-2">
            <Icon name="robot_sm" className="size-6 fill-gray-800 dark:fill-white" />
            <h4 className="my-2 text-gray-900 text-headline-3 lg:text-headline-w-2 dark:text-white">
              Smart Search
            </h4>
          </div>
        </div>
        {withSeeMore && (
          <button className="flex items-center text-primary-600 text-body-3">
            See more
            <div className="px-1 py-3">
              <Icon name="chevron_right" className="size-4 fill-primary-600" />
            </div>
          </button>
        )}
      </div>
      <div className="mt-2 hidden whitespace-pre-line text-gray-900 text-body-3">
        {`Dr.Tail AI analyzes your pet's symptoms and issues\nand suggests similar questions from our database.`}
      </div>
    </>
  )
}

export default Header
